import { useState } from "react";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import ImportUploadDialog from "./ImportUploadDialog";
import ImportReviewScreen from "./ImportReviewScreen";

export default function ImportInstructorFileButton({ onApplied }: { onApplied?: () => void }) {
  const [uploadOpen, setUploadOpen] = useState(false);
  const [reviewImportId, setReviewImportId] = useState<string | null>(null);

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setUploadOpen(true)}>
        <Upload className="h-4 w-4 mr-1" />
        Import Instructor File
      </Button>
      <ImportUploadDialog
        open={uploadOpen}
        onOpenChange={setUploadOpen}
        onParsed={(id) => { setUploadOpen(false); setReviewImportId(id); }}
      />
      {reviewImportId && (
        <ImportReviewScreen
          importId={reviewImportId}
          onClose={() => { setReviewImportId(null); onApplied?.(); }}
        />
      )}
    </>
  );
}
